const getters = {
  token: state => state.user.token,
  permission_routers: state => state.user.routers,
  usuario: state => state.user.usuario,
  drawer: state => state.user.drawer,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  rules: state => state.user.rules,
  setting: state => state.user.setting
}
export default getters
